import { render, staticRenderFns } from "./ProPatientsBPage.vue?vue&type=template&id=728085a2"
import script from "./ProPatientsBPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports